import { CredentialInterface } from '@interface/credential/credential.interface';
import { BaseStoreInterface } from '@interface/store/base-store.interface';
import { BaseStoreStructure } from '@util/constants/store.constants';

export const initialCredentialsState: BaseStoreInterface<CredentialInterface[]> = {
  ...BaseStoreStructure,
  data: [],
};
